import { render, staticRenderFns } from "./artlist.vue?vue&type=template&id=25e5cc31&scoped=true&"
import script from "./artlist.vue?vue&type=script&lang=js&"
export * from "./artlist.vue?vue&type=script&lang=js&"
import style0 from "./artlist.vue?vue&type=style&index=0&id=25e5cc31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e5cc31",
  null
  
)

export default component.exports